var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setDefaultOptions } from 'date-fns';
import * as Locales from 'date-fns/locale';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LANGUAGE } from '@/types';
import { convertToDotNotation, langCode } from '@/utils';
import { resources } from './resources';
const defaultNS = 'app';
export default i18n.use(initReactI18next).init({
    defaultNS,
    fallbackLng: LANGUAGE.ENGLISH_GB,
    interpolation: {
        escapeValue: false
    },
    lng: langCode,
    nonExplicitSupportedLngs: true,
    resources,
    returnEmptyString: false,
    returnNull: false,
    returnObjects: true,
    supportedLngs: Object.keys(resources)
});
export const addTranslations = (languages) => {
    for (const { code, strings } of languages) {
        const localResource = i18n.getResourceBundle(code, defaultNS);
        const localStrings = convertToDotNotation(localResource);
        const allTranslations = Object.assign(Object.assign(Object.assign({}, localStrings), strings.markdown), strings.standard);
        i18n.removeResourceBundle(code, defaultNS);
        i18n.addResourceBundle(code, defaultNS, allTranslations, true, true);
    }
    return i18n.reloadResources();
};
export const getLocale = () => {
    var _a, _b;
    const [locale, region] = i18n.language.split('-');
    // @ts-ignore
    return (_b = (_a = Locales[locale + region]) !== null && _a !== void 0 ? _a : Locales[locale]) !== null && _b !== void 0 ? _b : Locales.enGB;
};
export const setLanguage = (language = i18n.language) => __awaiter(void 0, void 0, void 0, function* () {
    yield i18n.changeLanguage(language);
    // set date-fns default locale
    const locale = getLocale();
    setDefaultOptions({ locale });
    // set language html attributes
    const htmlEl = document.querySelector('html');
    htmlEl.setAttribute('dir', i18n.dir());
    htmlEl.setAttribute('lang', language);
});
